import React from 'react';
import PropTypes from 'prop-types';
import { sizes } from 'reactive-container';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { AssetCard, AssetListRow } from 'components/AssetDisplayElement';

import { CardWrapper } from 'elements/Card';

export function AssetDisplayContainer({
  datum,
  type,
}) {
  switch (type) {
    case 'list':
      return (
        <AssetListRow
          assetInfo={datum}
        />
      );
    case 'card':
    default:
      return (
        <CardWrapper
          responsiveModifiers={{
            [sizes.XS]: ['1_per_row'],
            [sizes.SM]: ['2_per_row'],
            [sizes.MD]: ['3_per_row'],
            [sizes.LG]: ['4_per_row'],
            [sizes.XL]: ['5_per_row'],
          }}
        >
          <AssetCard
            assetInfo={datum}
          />
        </CardWrapper>
      );
  }
}

AssetDisplayContainer.propTypes = {
  datum: ImmutablePropTypes.contains({
    id: PropTypes.string,
  }).isRequired,
  type: PropTypes.oneOf(['card', 'list', 'map']).isRequired,
};

export default AssetDisplayContainer;



// WEBPACK FOOTER //
// ./containers/AssetDisplayContainer/index.js